import React, { useEffect, useState } from 'react';
import styles from './productCode.module.css';
import { Discount, Doc, Downarrow, Leaf, Pdf, Uparrow } from '../../../Svg';
import StockCard from '../../components/PageComps/ProductComps/StockCard/StockCard';
import SpecificationsTab from '../../components/PageComps/ProductComps/SpecificationsTab/SpecificationsTab';
import ProductDetails from '../../components/PageComps/ProductComps/ProductDetails/ProductDetails';
import ReqSamplePopup from '../../components/OtherComps/ReqSamplePopup/ReqSamplePopup';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getfilterproductcountThunk, getProductDetailsThunk, getSimilarProductThunk, resetFilterProductCount, setProductDetails, setProductPage, setSimilarPage } from '../../redux/productSlice';
import { addToCartThunk } from '../../redux/cartSlice';
import { addToScheduleThunk } from '../../redux/ScheduleSlice';
import ProductTable from '../../components/OtherComps/ProductTable/ProductTable';
import CatPagination from '../../utils/Pagination';
import { setLoginpopup } from '../../redux/customerSlice';



const ProductCode = () => {
    const [isPopupOpen, setPopupOpen] = useState(false);
    const { productDetails, loading, similarpage, similarProducts } = useSelector(state => state.products)


    const [selectedAttributes, setSelectedAttributes] = useState({});
    // State to store the selected category

    const [selectedCategoryId, setSelectedCategory] = useState(productDetails?.categories?.[0]?._id || '');
    const { isLoggedin } = useSelector((state) => state.customer)


    const dispatch = useDispatch();
    const navigate = useNavigate()

    const [quantities, setQuantities] = useState({});
    const [cartLoading, setLoadingCart] = useState({});
    const [scheduleLoading, setScheduleloading] = useState({})
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [limit, setLimit] = useState(10)
    const similarProductsdata = similarProducts?.data || []
    const totalPages = similarProducts?.totalPages
    const totalItems = similarProducts?.totalItems
    const itemsPerPage = similarProducts?.limit


    // calculate start & end of items -------------------
    const start = (similarpage - 1) * limit + 1;
    const end =
        totalPages === similarpage
            ? totalItems
            : (similarpage - 1) * limit + limit;

    const params = useParams();
    const rawId = params['*'] || params.id || '';
    const id = rawId ? decodeURIComponent(rawId).trim() : '';

    const openPopup = () => {
        setPopupOpen(true);
    };

    const closePopup = () => {
        setPopupOpen(false);
    };

    const handleQuantityChange = (productId, value) => {
        setQuantities((prev) => ({
            ...prev,
            [productId]: value,
        }));
    };

    const handleCheckboxChange = (product, isChecked) => {

        setSelectedProducts((prevState) => {
            if (isChecked) {
                return [...prevState, product];
            } else {
                return prevState.filter((p) => p._id !== product?._id);
            }
        });
    };

    useEffect(() => {
        if (productDetails?.categories?.length) {
            const lastCat = productDetails.categories[productDetails.categories.length - 1];
            setSelectedCategory(lastCat?._id || productDetails?.categories[0]?._id);
        }
    }, [productDetails]);

    useEffect(() => {
        setSelectedAttributes({})
        setSelectedCategory('')
        dispatch(setProductDetails({}))
        dispatch(resetFilterProductCount())
        if (id) {
            dispatch(getProductDetailsThunk(id))
        }
        // dispatch(getSimilarProductThunk(id))
    }, [dispatch, id])




    const data = {
        selectedCategoryId,
        selectedAttributes,
        currentProductId: id
    }

    useEffect(() => {
        if (id && selectedCategoryId) {
            dispatch(getfilterproductcountThunk(data))
        }
    }, [dispatch, selectedAttributes, selectedCategoryId, id])

    useEffect(() => {
        if (id) {
            dispatch(getSimilarProductThunk(`?id=${encodeURIComponent(id)}&page=${similarpage}&limit=${limit}`))
        }
    }, [id, similarpage, limit])

    const addtoCart = async (from, productId) => {

        if (!isLoggedin) {
            return dispatch(setLoginpopup(true))
        }
        const products = Object.entries(quantities).map(([id, quantity]) => ({
            productId: id,
            totalQty: parseInt(quantity, 10),
            quantity: parseInt(quantity, 10),
        }));
        if (from == 'cart') {
            setLoadingCart((prev) => ({ ...prev, [productId]: true }));
            const status = await dispatch(addToCartThunk(products))
            if (status?.payload === 200) {
                // navigate('/cart')
                setQuantities({})
            }
            setLoadingCart((prev) => ({ ...prev, [productId]: false }));
        }
        else {
            setScheduleloading((prev) => ({ ...prev, [productId]: true }));
            const status = await dispatch(addToScheduleThunk(products))

            if (status?.payload === 200) {
                // navigate('/scheduleCart')
                setQuantities({})
            }
            setScheduleloading((prev) => ({ ...prev, [productId]: false }));
        }
    }


    if (loading) {
        return (
            <div>Loading.....</div>
        )
    }

    return (
        <>
            <div className={styles.prodCodeContainer}>
                <div className={styles.prodCodeCol1}>
                    <div className={styles.prodDetail}>
                        <ProductDetails
                            productOverview={productDetails?.productOverview}
                            category={productDetails?.categories}
                            assets={productDetails?.assets}
                        />
                    </div>
                    <div className={styles.prodSpeci}>
                        <SpecificationsTab
                            attributes={productDetails?.attributes}
                            additionalResources={productDetails?.additionalResources}
                            selectedAttributes={selectedAttributes}
                            setSelectedAttributes={setSelectedAttributes}
                            category={productDetails?.categories}
                            setSelectedCategory={setSelectedCategory}
                            selectedCategory={selectedCategoryId}
                            data={data}
                        />
                    </div>
                </div>
                <div className={styles.prodCodeCol2}>
                    <div className={styles.prodCodeStock}>
                        <StockCard
                            inventory={productDetails?.inventory}
                            quantityTable={productDetails?.quantityTable}
                            isLoggedin={isLoggedin}
                            additionalResources={productDetails?.additionalResources}
                            productOverview={productDetails?.productOverview}
                            id={productDetails?._id}
                            status={productDetails?.status}
                            gst={productDetails?.gst}
                        />
                    </div>
                    <div className={styles.prodCodeSample}>
                        <strong>For sample products:</strong><br />
                        <span>You can request for samples, click here</span><br />
                        <a href="#" className={styles.dataSheetLink} onClick={openPopup}>
                            Request for samples
                        </a>
                        {isPopupOpen && <ReqSamplePopup onClose={closePopup} id={id} />}
                    </div>
                    <div className={styles.prodCodeBulk}>
                        <strong>For Bulk Pricing:</strong><br />
                        <span> Write a mail to us directly to </span><br />
                        <a href="#" className={styles.dataSheetLink}>
                            company@electrowiz.com
                        </a>
                    </div>
                </div>
            </div>
            {similarProductsdata?.length > 0 &&
                <>
                    <div style={{ fontSize: 18, fontWeight: '600', marginLeft: 20 }}>Alternative products</div>
                    <ProductTable
                        products={similarProductsdata}
                        quantities={quantities}
                        addtoCart={addtoCart}
                        handleQuantityChange={handleQuantityChange}
                        handleCheckboxChange={handleCheckboxChange}
                        cartLoading={cartLoading}
                        scheduleLoading={scheduleLoading}
                        selectedProducts={selectedProducts}
                    />
                    <CatPagination
                        start={start}
                        end={end}
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        setPage={setSimilarPage}
                        page={similarpage}

                    />
                </>
            }
        </>
    );
};

export default ProductCode;
